export default __webpack_public_path__ + "static/media/icon-visa.34488a56.svg";